module.exports = __webpack_public_path__ + "media/country_flags/cl-c650ffb7.png";